import { ApiUtil as api } from '@/utils/api.util.js'

export class ServiceLevelService {
  static URL = process.env.API_URL + process.env.API_VER
  static RESOURCE = '/service-levels/'

  static all(queryParams = {}) {
    return api.get(this.URL + this.RESOURCE, queryParams)
  }

  static create(queryParams = {}) {
    return api.post(this.URL + this.RESOURCE, queryParams)
  }

  static archive($id, queryParams = {}) {
    return api.put(this.URL + this.RESOURCE + $id + '/archive', queryParams)
  }
  
  static restore($id, queryParams = {}) {
    return api.put(this.URL + this.RESOURCE + $id + '/restore', queryParams)
  }

}



// WEBPACK FOOTER //
// ./src/services/serviceLevel.service.js